import { render, staticRenderFns } from "./FormsListTable.vue?vue&type=template&id=a86a39b6&scoped=true&"
import script from "./FormsListTable.vue?vue&type=script&lang=js&"
export * from "./FormsListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86a39b6",
  null
  
)

export default component.exports